<template>
  <gmap-map :center="center" :zoom="14" :options="{styles: googleMapStyles}"></gmap-map>
</template>

<script>
import googleMapStyles from '@/assets/googleMap/styles.json';

export default {
  data() {
    return {
      center: { lat: 47.40759, lng: 8.5076 },
      googleMapStyles,
    };
  },
};
</script>

<style lang="scss" scoped>
.vue-map-container {
  width: 100% ;
  height: 360px;
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/views/ContactUs/GoogleMap.vue